import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from "../../../../sessionStorage";

export const savedQuoteEmailDrip = (email) => {

  const sessionId = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY).sessionId;
  const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;

  const body = {
    sessionId: sessionId,
    emailAddress: email,
  };

  fetch(`${covrServicesUrl}/api/SaveQuote/DisableSavedQuoteDrip`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'SessionId': sessionId,
    },
    body: JSON.stringify(body),
  }).then(response => response.json());
}
